<div class="zn-step-content-sections">
  <div class="zn-step-content-section zn-step-content-section--selected zn-full-height">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.SelectedStandsTable.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Description') | abpLocalization }}</p>
        </div>
        <div class="zn-step-content-section-actions">
          <zn-button
            [loading]="loading()"
            loadingIconPosition="left"
            type="primary"
            size="normal"
            iconLeft="bi bi-calculator"
            [label]="(localizationKeyPrefix + '.Action') | abpLocalization"
            (clicked)="onCalculateProductivity()"
          ></zn-button>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-table">
        <div class="zn-table-scroll">
          <table class="zn-table-element">
            <thead>
              <tr>
                <th>{{ columnHeaderKeys.stand | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.cycle | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.rotation | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.area | abpLocalization }}</th>
                <th class="zn-table-highlight">{{ columnHeaderKeys.productivityParameters | abpLocalization }}</th>
                <th class="zn-table-highlight">{{ columnHeaderKeys.dab | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.inventoryType | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.inventoryYear | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.inventoryDate | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.workFront | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.volumePerHectare | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.treeVolume | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.projectedTotalVolume | abpLocalization }}</th>
              </tr>
            </thead>
            <tbody>
              @for (row of rows(); track row.standName) {
                <tr>
                  <td>{{ row.standName }}</td>
                  <td>{{ row.cycleNumber }}</td>
                  <td>{{ row.rotationNumber }}</td>
                  <td>{{ row.standArea }}</td>
                  <td class="zn-table-highlight">
                    <zn-simple-select
                      [class.is-invalid]="isFieldInvalid(row, 'productivityParameterId')"
                      [options]="productivityParameterOptions()"
                      [(ngModel)]="row.productivityParameterId"
                      (ngModelChange)="onProductivityParameterChange(row)"
                    ></zn-simple-select>
                  </td>
                  <td class="zn-table-highlight">
                    <input
                      class="zn-table-field"
                      [class.invalid]="isFieldInvalid(row, 'dab')"
                      type="number"
                      [placeholder]="enterNumberKey | abpLocalization"
                      [attr.aria-label]="columnHeaderKeys.dab | abpLocalization"
                      [(ngModel)]="row.dab"
                      (ngModelChange)="onDab(row)"
                    />
                  </td>
                  <td>{{ row.inventoryTypeName }}</td>
                  <td>{{ row.inventoryYear }}</td>
                  <td>{{ row.inventoryDate }}</td>
                  <td>{{ row.teamName }}</td>
                  <td>{{ row.projectedVolumePerHectare }}</td>
                  <td>{{ row.projectedTreeVolume }}</td>
                  <td>{{ row.projectedTotalVolume }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
